import { ReportSeriesModel } from '../../../../Common/Reports/models/report-series.model';
import { chartColors } from '../../../../Common/Charts/enums/chart-colors.enum';

export class WordCloudSeriesModel extends ReportSeriesModel {
    accentColor: string = chartColors.agprBlue;
    sentimentType: 'positive' | 'negative';
    /** Must be localized */
    tooltipLabel: string;
    eventHandlers?: {
        wordClicked: (tagLabel: string) => void;
        viewPostsClicked: (tagLabel: string) => void;
    };

    clone(): WordCloudSeriesModel {
        const clone = super.clone() as WordCloudSeriesModel;
        clone.accentColor = this.accentColor;
        clone.sentimentType = this.sentimentType;
        clone.tooltipLabel = this.tooltipLabel;
        clone.eventHandlers = {
            wordClicked: this.eventHandlers?.wordClicked,
            viewPostsClicked: this.eventHandlers?.viewPostsClicked
        };

        return clone;
    }
}
